import script from "./InvoiceImportDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceImportDialog.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceImportDialog.vue?vue&type=style&index=0&id=04cdaf84&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04cdaf84"]])

export default __exports__